const isValidDate = (dateString: string) => {
  const [year, month, day] = dateString.split('-').map(Number)

  if (Number.isNaN(year) || Number.isNaN(month) || Number.isNaN(day)) {
    return false
  }

  if (year <= 0 || month <= 0 || day <= 0) {
    return false
  }

  // Basic month check
  if (month > 12) {
    return false
  }

  // Basic day check
  if (day > 31) {
    return false
  }

  const utcTimestamp = Date.UTC(year, month - 1, day)
  const date = new Date(utcTimestamp)

  const isSameYear = date.getUTCFullYear() === year
  // Months start from 0
  const isSameMonth = date.getUTCMonth() + 1 === month
  const isSameDay = date.getUTCDate() === day

  return isSameYear && isSameMonth && isSameDay
}

export default isValidDate
